import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import {
  amDataService,
  loaderService,
  ssDialogService,
  userService
} from 'app/services';
import controller from './attach-report-package-report.controller';
import directive from './attach-report-package-report.directive';


export default angular.module('app.components.reports.packageReports.attachReportPackageReport', [
  alerts,
  amDataService,
  constants,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('prAttachReportPackageReport', directive)
  .controller('AttachReportPackageReportController', controller)
  .name;

console.log('app.components.reports.packageReports.attachReportPackageReport created');
